import { FC, MouseEvent } from "react";
import {
  GridActionsCellItem,
  useGridApiContext,
  GridApi,
} from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { Save as SaveIcon } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { ActionButtonProps } from "./AssociatesTable";

export const SaveButton: FC<ActionButtonProps> = ({ id }) => {
  const apiRef = useGridApiContext<GridApi>();
  const { t } = useTranslation();
  const label = t("save");

  const onClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    apiRef.current.stopRowEditMode({ id });
  };

  return (
    <GridActionsCellItem
      icon={
        <Tooltip title={label}>
          <SaveIcon color="primary" />
        </Tooltip>
      }
      label={label}
      onClick={onClick}
    />
  );
};
